import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import ShareButtons from "../components/ShareButtons";


const Home = ({ user }) => {
  const { t } = useTranslation();
  const featureIcons = [
    "https://modularobjects.com/svg/kitchen-cabinets-2-svgrepo-com.svg",
    "https://modularobjects.com/svg/3dcube-svgrepo-com.svg",
    "https://modularobjects.com/svg/strategy-idea-svgrepo-com.svg",
  ];
  

  return (
    <div className="p-4 space-y-12">
      {/* Hero section */}
      <section className="text-center py-16 bg-background-light dark:bg-background-dark rounded shadow-md border border-gray-100 dark:border-none">
        <h1 className="text-4xl font-bold text-primary-light dark:text-primary-dark mb-4">
          {t("home_title")}
        </h1>
        <p className="text-lg text-text-light dark:text-text-dark max-w-2xl mx-auto">
          {t("home_description")}
        </p>
        <div className="mt-6">
          <Link
  to={user ? "/dashboard" : "/projects"}
  id="homeMainButton"
  onClick={() => {
    window.dataLayer?.push({
      event: "home_main_click",
      user_status: user ? "logged_in" : "guest",
      user_id: user?.uid || null
    });
  }}
  className="bg-primary-light dark:bg-primary-dark text-white dark:text-black px-6 py-2 rounded hover:opacity-90 inline-block"
>
  {user ? t("get_started") : t("get_projects")}
</Link>

        </div>
      </section>

      {/* Features */}
      <section className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {[1, 2, 3].map((i) => (
          <div
            key={i}
            className="bg-background-light dark:bg-background-dark p-6 rounded shadow-md border border-gray-100 dark:border-gray-800 hover:shadow-lg transition text-center"
          >
            <img
              src={featureIcons[i - 1]}
              alt=""
              className="h-24 w-24 mx-auto mb-3 filter dark:invert"
            />

            <h3 className="text-xl font-semibold text-primary-light dark:text-primary-dark mb-2">
              {t(`feature_${i}_title`)}
            </h3>
            <p className="text-text-light dark:text-text-dark">
              {t(`feature_${i}_desc`)}
            </p>
          </div>
        ))}
      </section>

      {/* Novi element za Kuhinje */}
<section className="text-center py-16 bg-background-light dark:bg-background-dark rounded shadow-md border border-gray-100 dark:border-none">
  <h2 className="text-2xl font-bold text-primary-light dark:text-primary-dark mb-4">
    {t("kitchens_title", "Kuhinje po meri")}
  </h2>
  <p className="text-text-light dark:text-text-dark max-w-xl mx-auto mb-6">
    {t("kitchens_description", "Pogledajte ponudu i zatražite svoj besplatan 3D plan kuhinje.")}
  </p>
  <Link
    to="/kuhinje"
    onClick={() => {
      window.dataLayer?.push({
        event: "home_kitchens_click",
        user_status: user ? "logged_in" : "guest",
        user_id: user?.uid || null
      });
    }}
    className="bg-primary-light dark:bg-primary-dark text-white dark:text-black px-6 py-2 rounded hover:opacity-90 inline-block"
  >
    {t("see_kitchens", "Pogledaj kuhinje")}
  </Link>
</section>


      {/* Placeholder for CTA or integration info */}
      <section className="text-center py-16 border-t">
        <h2 className="text-2xl font-bold text-primary-light dark:text-primary-dark mb-4">
          {t("explore_more")}
        </h2>
        <p className="text-text-light dark:text-text-dark max-w-xl mx-auto">
          {t("explore_description")}
        </p>
      </section>

      <div className="mt-10 flex justify-center">
        
  <ShareButtons
  kind="page"
  post={{
    title: t("home_title"),
    description: t("home_description"),
    image: "/images/og/home.png",
    slug: "home",
  }}
/>
</div>

    </div>
    
  );
};

export default Home;
